import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  setExternalLink,
  setShowExternalPopup,
} from "../../../redux/slice/slicePopup";

const SocialLinks = () => {
  const dispatch = useDispatch();
  const handlePopupLink = (link) => {
    dispatch(setShowExternalPopup(true));
    dispatch(setExternalLink(link));
  };
  return (
    <div className="col-12 col-sm-12 col-md-12 col-lg-3 foot_social wow fadeInRight">
      <ul>
        <li>
          <a
            className="facebook"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handlePopupLink("https://www.facebook.com/NEEPCOlimited/");
            }}
            aria-label="Facebook"
          >
            <i className="fab fa-facebook-f" aria-hidden="true"></i>
          </a>
        </li>
        <li>
          <a
            className="x-twitter"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handlePopupLink("https://x.com/NEEPCOLtd");
            }}
            aria-label="x.com"
          >
            <img
              alt="x.com"
              src={`${process.env.REACT_APP_IMAGE_URL_FRONTEND}/images/s_tw.png`}
              aria-hidden="true"
            />
          </a>
        </li>

        <li>
          <a
            className="linked-in"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handlePopupLink(
                "https://www.linkedin.com/company/100496185/admin/dashboard/",
              );
            }}
            aria-label="LinkedIn"
          >
            <i className="fab fa-linkedin" aria-hidden="true"></i>
          </a>
        </li>
        <li>
          <a
            className="instagram"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handlePopupLink("https://www.instagram.com/neepcoindia/");
            }}
            aria-label="Instagram"
          >
            <i className="fab fa-instagram" aria-hidden="true"></i>
          </a>
        </li>
        <li>
          <a
            className="youtube"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handlePopupLink(
                "https://www.youtube.com/channel/UCcoSJQg7UJLLYGBxJkiNu_g",
              );
            }}
            aria-label="YouTube"
          >
            <i className="fab fa-youtube" aria-hidden="true"></i>
          </a>
        </li>
        {/* <li>
          <a
            className="youtube"
            href="https://www.youtube.com/channel/UCcoSJQg7UJLLYGBxJkiNu_g"
            target="_blank"
          >
            <i className="fab fa-youtube"></i>
          </a>
        </li> */}
      </ul>
    </div>
  );
};

export default SocialLinks;
